import "./App.css";
import { useMemo } from "react";

import Minter from "./Minter";

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";


const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [getPhantomWallet(), getSolflareWallet(), getSolletWallet(), getMathWallet() ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>
      <div id="mobileNavContainer" className="mobile-nav">
        <div className="mobile-nav-close-button" >
          <img src="/icons/close.svg" alt="" onClick={toggleMenu}/>
        </div>
        <ul>
          <li>
            <img className="mobile-nav-logo" src="/img/logo.png" alt="" />
          </li>
          <li>
            <a href="/#link1" onClick={toggleMenu}>
              MINT ASTRO
            </a>
          </li>
          <li>
            <a href="/#link2" onClick={toggleMenu}>
              DETAILS
            </a>
          </li>
          <li>
            <a href="/#link3" onClick={toggleMenu}>
              LAUNCH
            </a>
          </li>
          <li>
            <a href="/#link4" onClick={toggleMenu}>
              FAQ
            </a>
          </li>
          <li>
            <div className="social-icons">
            <a href="https://twitter.com/solacommand"><img className="nav-social" src="/icons/twitter.svg" alt="Twitter" /></a>
            <a href="https://discord.gg/9TtWpwxvfH"><img className="nav-social" src="/icons/discord.svg" alt="Discord Channel" /></a>
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-menu-button" onClick={toggleMenu}>
        <img src="/icons/menu.svg" alt="" />
      </div>
      <nav>
        <div className="nav-container">
          <img className="nav-logo" src="/img/logo.png" alt="" />
          <a className="hide-800" href="/#link1">
            MINT YOUR ASTRO
          </a>
          <a className="hide-800" href="/#link2">
            LAUNCH
          </a>
          <a className="hide-800" href="/#link3">
            NFT DETAILS
          </a>
          <a className="hide-800" href="/#link4">
            FAQ
          </a>
          <div className="social-icons hide-800">
          <a href="https://twitter.com/solacommand" target="_blank" rel="noreferrer noopener"><img className="nav-social" src="/icons/twitter.svg" alt="Twitter" /></a>
          <a href="https://discord.gg/9TtWpwxvfH" target="_blank" rel="noreferrer noopener"><img className="nav-social" src="/icons/discord.svg" alt="Discord Channel" /></a>
          </div>
        </div>
      </nav>
      <div className="content-wrapper">            
      <img src="/img/sola banner11.png" alt=""  width="900" height="120" /></div>      
      <div className="content-wrapper">
          <header className="card" id="link1">
            <div style={{ padding: "0 24px 0 24px 0" }}>
              <h3 className="text-secondary-color">Welcome To The</h3>
              <h1 className="pb-3">SOLA COMMAND MINT</h1>
              <p className="text-secondary-color">
              To mint an ASTRO NFT first connect your wallet. You can connect 
              Phantom, Solflare, Sollet and Mathwallet only. If you do not yet 
              have one, we recommend Phantom as it has nice display interface 
              for your minted NFT. You can create one here: <a href= "https://phantom.app" target="_blank" rel="noreferrer noopener">phantom.app</a>
              </p>
            </div>
            <div>
              <ThemeProvider theme={theme}>
                <ConnectionProvider endpoint={endpoint}>
                  <WalletProvider wallets={wallets} autoConnect>
                    <WalletDialogProvider>
                      
                        <Minter
                          candyMachineId={candyMachineId}
                          
                          connection={connection}
                          startDate={startDateSeed}
                          txTimeout={txTimeout}
                          rpcHost={rpcHost}
                        />
                      
                    </WalletDialogProvider>
                  </WalletProvider>
                </ConnectionProvider>
              </ThemeProvider>
            </div>
          </header>

          <div id="link2" className="container">
          <p><h2>LAUNCH</h2>
          As part of the launch we will be running a series of giveaways, which 
          will include chances to win free nfts and whitelist places. In order to 
          be eligible it will be a requirement that cadets join the discord server 
          and take part in shilling activities. We will also be giving Sola Credits 
          (tokens) to nft holders as part of our airdrops. 
          </p><br></br>
          <p>
          <h3>OFFICIAL LINKS</h3>
          <li><a href= "https://ssa.systemtechs.co.uk/" target="_blank" rel="noreferrer noopener">WEBSITE</a> </li>
          <li><a href= "https://ssa.systemtechs.co.uk/Whitepaper.pdf" target="_blank" rel="noreferrer noopener">WHITEPAPER </a> </li>
          <li><a href= "https://twitter.com/solacommand" target="_blank" rel="noreferrer noopener">TWITTER</a> </li>
          <li><a href= "https://solsea.io/collection/61a23f7b4770c5efff3caca0" target="_blank" rel="noreferrer noopener">SOLSEA </a> </li>
          <li><a href= "https://discord.gg/9TtWpwxvfH" target="_blank" rel="noreferrer noopener">DISCORD </a> </li>
          </p>
          </div>

          <div id="link3" className="container card">
            <h1 className="pb-3">NFT DETAILS</h1>
            <p>
            Sola Space academy will launch with a Beautiful collection of nfts. 
            Each of the 4321 Minted nfts will have a unique set of combination 
            attributes, with varying backgrounds, planets, suit, flags. There are 
            Seven Cadets, TAKAO, VIKTOR, VYOMA, CHRIS, MAE, KALPANA and AREUM.
            Our initial intention is to generate a community of users that will 
            assist in the growth of the project with ideas and NFT purchases to 
            support the game development. The long term goal is to create a gaming 
            trilogy which will begin here on Earth in the Academy. The Second 
            and Third instalments will take us out of orbit and into the Metaverse, 
            and will be guided by the community vision for the franchise.  Given 
            the turbulent nature of the blockchain-based assets currently, we want 
            to wait until the second instalment before integrating the proposed 
            Sola credits Token into the gameplay, as we need to see how the Metaverse 
            plays out, to ensure security for our Cadets. We hope to build a strong 
            global player base, with multiplayer interactions, and in-game purchases 
            to ensuring the longevity of SSA. 
              </p>
          </div>

          <div id="link4" className="container faq">
            <h1 style={{ padding: "0 0 24px 0" }}>FAQ</h1>
            <div>
              <h4>HOW TO CONNECT MY WALLET?</h4>
              <p>
              After you create your Phantom wallet you will just have to click on the 
              button on the header of this page “connect your wallet” and make sure 
              you are on the Solana Mainnet Beta network.
              </p>

              <hr />
            </div>

            <div>
              <h4>WHAT IS MINTING?</h4>
              <p>
              Minting an ASTRO means that you are buying digital art which becomes a 
              part of the Solana blockchain. Your digital artwork is represented as 
              an NFT so it can be traded in the market and digitally tracked as it 
              is resold or collected again in the future.
              </p>

              <hr />
            </div>

            <div>
              <h4>WHERE CAN I VIEW MY NFTS AFTER MINTING?</h4>
              <p>
              Once you have minted an ASTRO NFT, you will be able to see it by 
              opening your Phantom wallet and clicking the box icon. They will 
              also be uploaded to Solsea where they can be traded. 
              </p>

              <hr />
            </div>
            <br>
            </br>
            <h4>© SYSTEMTECHS 2022 - Powered by Solana Blockchain</h4>
          </div>
      </div>
    </div>
  );
};

export default App;
